<template>
  <div
    id="lang-picker"
    class="lang-picker comp-start"
    :class="
      !selectedItem || selectedItem.id === 'Loading' || null
        ? 'tw-pointer-events-none'
        : ''
    "
  >
    <div id="dropdownMenu" ref="dropdownMenu" class="dropdown">
      <button
        id="langButton"
        ref="langButton"
        class="btn dropdown-button"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-display="static"
        :class="!showIcon ? 'dropdown-border' : 'dropdown-border-open'"
        @click="onMenuClick"
      >
        <div class="tw-flex tw-items-center tw-justify-center">
          <div
            v-if="!selectedItem || selectedItem.id === 'Loading' || null"
            class="float-left !tw-w-[167px]"
          >
            <div class="tw-flex tw-h-[24px] tw-w-[28px]">
              <LottieAnimation
                ref="anim"
                :animation-data="getProgressAnimation()"
                :auto-play="true"
                :loop="true"
              />
            </div>
          </div>
          <div
            v-else
            class="!tw-min-w-[167px] tw-h-[24px] tw-flex tw-items-center tw-justify-center"
          >
            <span class="float-left flag">
              <img :src="getImgUrl(selectedItem.id)" width="20" />
            </span>

            <span
              :style="dDWidth"
              class="float-left select-placeholder"
              :class="selectedItem ? '' : 'select-placeholder-default'"
              >{{
                isMobile ? selectedItem["iso_639-1"] : selectedItem.native_name
              }}</span
            >
            <span class="float-right button-arrow dropdown-button-arrow">
              <img src="@/assets/img/lang_picker_icon.svg" />
            </span>
          </div>
        </div>
      </button>

      <div
        ref="lang-dropdown-menu"
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
      >
        <form
          :id="'langScroll' + isMobile"
          :ref="'langScroll' + isMobile"
          class="dropdown-scroll"
        >
          <a
            v-for="item in languageList"
            :key="item.id"
            class="dropdown-item"
            href="javascript:void(0)"
            :class="selectedItem.id === item.id ? 'selected-item' : ''"
            @click="onSelectItem(item)"
          >
            <div class="dropdown-item-text-division">
              {{ item.native_name }}
            </div>
          </a>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Utils, { getProgressAnimation } from "@/utils/utilities";
import $ from "jquery";
import store from "@/store";
import { useRoute } from "vue-router";
import { DEFAULT_LANG_ID, localStorageKey } from "@/utils/constants";
import { LottieAnimation } from "lottie-web-vue";

@Component({
  components: {
    LottieAnimation,
  },
})
export default class LanguagePicker extends Vue {
  public showIcon = false;
  public Route = useRoute();
  public haha = "";
  public selectPlaceholder = "Loading";
  public selectedItem: any = {
    id: "Loading",
    name: "Loading",
    native_name: "Loading",
    "iso_639-1": "Loading",
  };
  public list = [];
  public dropdownWidth = 0;
  public flag = "@/assets/img/flags/loading.svg";

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get languageList() {
    return store.state.LanguagePicker.languageList;
  }

  getProgressAnimation() {
    return getProgressAnimation();
  }

  @Watch("languageList")
  changeLanguageList() {
    this.setUpData();
  }

  @Prop({ required: false, default: false })
  public isMobile!: boolean;

  @Prop({ default: false }) public isHeaderLogo!: boolean;

  mounted() {
    if (localStorage.getItem(localStorageKey.languageList) == null) {
      this.$store.dispatch(
        "LanguagePicker/setSelectedLanguage",
        DEFAULT_LANG_ID,
      );
    } else {
      this.setUpData();
    }
  }
  adjustDropdownWidth() {
    this.dropdownWidth = Utils.dropDownFitContent(
      Object.values(this.languageList),
      "",
      "lang",
    );
    if (window.innerWidth >= 3840) {
      this.dropdownWidth += 60;
    }
  }

  setUpData() {
    this.selectedItem = Object.values(this.languageList).filter(
      (item: any) =>
        item.id.toLowerCase() === this.languageSelected.toLowerCase(),
    )[0];
    this.adjustDropdownWidth();
  }

  getImgUrl(img = "default") {
    try {
      return require("@/assets/img/flags/" + img.toLowerCase() + ".svg");
    } catch {
      return require("@/assets/img/flags/loading.svg");
    }
  }

  get dDWidth() {
    return {
      width: `${
        window.innerWidth > 500 ? this.dropdownWidth + 1 + "px" : "100%"
      } !important`,
      "padding-bottom": "0px",
    };
  }

  onMenuClick() {
    const nextState = !this.showIcon;
    if (nextState) {
      let width = ($(this.$refs.dropdownMenu as any) as any).width();
      $(this.$refs["langScroll" + this.isMobile] as any).width(width);
      $(this.$refs["lang-dropdown-menu"] as any).addClass("show");
    } else {
      $(this.$refs["lang-dropdown-menu"] as any).removeClass("show");
    }
    this.showIcon = nextState;
  }

  async onSelectItem(item: any) {
    (window as any).productFruits?.services?.destroy();
    await this.$store.dispatch("LanguagePicker/setSelectedLanguage", item.id);
    this.selectedItem = item;
    this.$emit("langChanged");
    if (!this.isHeaderLogo) {
      await this.$store.dispatch("User/updateUserProfile", {
        data: { languageId: item?.id || DEFAULT_LANG_ID },
      });
    }
    if (this.Route?.name !== "verifyorganisation") {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  }
}
</script>

<style scoped>
.select-card-ques {
  color: #231f20;
}
.lang-picker .dropdown-button {
  background: #ffffff;
  border: 1.72324px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 5.74413px rgba(183, 183, 183, 0.4);
  border-radius: 3.44648px;
  width: fit-content;
  display: flex !important;
  align-items: center;
  padding-left: 5px;
}

.lang-picker .dropdown-button-arrow {
  padding-left: 10px;
}

.lang-picker {
  margin-left: 20px;
  z-index: 1090;
}
.lang-picker .flag {
  padding-right: 15px;
  padding-left: 5px;
}

.lang-picker .select-placeholder {
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  text-align: left;
  color: rgb(33, 37, 41);
}
.lang-picker .select-placeholder-default {
  color: #b7b7b7;
}
.lang-picker .dropdown-menu {
  padding: 0px;
}

.lang-picker .dropdown-menu .dropdown-scroll {
  box-shadow: 0px 0px 5.74413px rgba(183, 183, 183, 0.4);
}

.lang-picker .dropdown-menu.show {
  margin-top: 0px;
  border: none;
  display: block;
  background: transparent;
}
.lang-picker .dropdown-item {
  overflow-x: hidden;
  font-size: 13px;
  font-weight: 500 !important;
  padding: 10px 10px 10px 20px;
  background: white;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #231f20 !important;
  font-weight: unset;
  text-decoration: unset !important;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: 100%;
}
.lang-picker .selected-item {
  font-weight: 500 !important;
  font-size: 13px !important;
  line-height: 19px !important;
  display: flex !important;
  align-items: center !important;
  background: #387dff !important;
  color: #ffffff !important;
  border: none;
}

@media (max-width: 500px) {
  .lang-picker .dropdown {
    width: 98px;
  }
  .lang-picker .dropdown-button {
    width: 100%;
  }
}

.lang-picker .dropdown-item-text-division {
  width: 90%;
  white-space: normal;
  word-break: break-word;
  margin: 0px;
  /* position:relative;
  left:5%; */
}

.lang-picker .dropdown-checkbox-circle-division {
  display: inline-block;
}

@media (max-width: 812px) and (min-width: 769px) and (orientation: landscape) {
  .lang-picker .dropdown-button {
    width: 118px !important;
  }
}

@media (min-width: 3840px) {
  .flag {
    zoom: 2;
  }
  .dropdown-button-arrow {
    zoom: 2;
  }
  .lang-picker .select-placeholder {
    font-size: 30px !important;
    line-height: 38px;
  }

  .lang-picker .dropdown-item {
    font-size: 30px;
    padding: 20px 20px 20px 40px;
    line-height: 38px;
    border-bottom: 2px solid rgba(183, 183, 183, 0.25);
  }
  .lang-picker .selected-item {
    font-size: 30px !important;
    line-height: 38px !important;
  }
}

@media screen and (max-width: 650px) {
  .lang-picker .dropdown-button {
    width: 85px !important;
  }
  .lang-picker .flag {
    padding-right: 5px !important;
  }
  .lang-picker .button-arrow {
    padding-left: 5px !important;
  }
}
</style>
